export default __webpack_public_path__ + "static/hero-home-56a7fb9bcd9c45076502e7a2bf62a271.png";